import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Section from '../../components/Section';
import SectionHeader from '../../components/SectionHeader';
import SectionBody from '../../components/SectionBody';

import { ReactComponent as Icon } from '../../assets/icons/OM.svg';
import Image from '../../assets/icons/OM_grey.svg';

const useStyles = makeStyles(() => ({
    content: {
        fontSize: 16,
        marginBottom: 20
    },
    topText: {
        fontFamily: 'SourceSansPro-Regular',
    },
    links: {
        fontFamily: 'SourceSansPro-SemiBold',
    },
    listItem: {
        marginBottom: 20,
    },
    link: {
        color: '#ed1c24'
    }
}));

const OrderManagement = ({ setPage }) => {
    const classes = useStyles();

    return (
        <Section backgroundImage={Image}>
            <SectionHeader title="Order Management/Orchestrator">
                <Icon width={40} height={40} />
            </SectionHeader>
            <SectionBody>

                <ul className={classes.links}>

                    <li className={classes.listItem}>
                        <a href="/docs/ordermanagement" className="linkText"
                            underline='none' rel='noopener noreferrer'>Documentation</a> </li>
                    <li className={classes.listItem}>
                        <Link
                            className="linkText"
                            to={"/releaseversion/ordermanagement"}
                            underline='none'
                            rel='noopener noreferrer'>Releases & Changelog</Link>

                    </li>
                    <li className={classes.listItem}>
                        <Link
                            to={{ pathname: process.env.REACT_APP_GET_SUPPORT_ORDER_MANAGEMENT_URL }}
                            className="linkText"
                            underline='none'
                            target='_blank'
                            rel='noopener noreferrer'>
                            Support
                        </Link>
                    </li>
                    <li className={classes.listItem}>
                        <Link
                            to={{ pathname: process.env.REACT_APP_FEEDBACK_ORDER_MANAGEMENT_URL }}
                            className="linkText"
                            underline='none'
                            target='_blank'
                            rel='noopener noreferrer'>
                            Roadmap
                        </Link>
                    </li>
                </ul>
            </SectionBody>
        </Section>
    );

}

export default OrderManagement;
